export const getBounds = points => {
  const validPoints = points.filter(
    ([longitude, latitude]) => Number.isFinite(longitude) && Number.isFinite(latitude)
  );

  if (!validPoints.length) return null;

  return validPoints.reduce(
    (bounds, [longitude, latitude]) => [
      [Math.min(bounds[0][0], longitude), Math.min(bounds[0][1], latitude)],
      [Math.max(bounds[1][0], longitude), Math.max(bounds[1][1], latitude)]
    ],
    [
      [Infinity, Infinity],
      [-Infinity, -Infinity]
    ]
  );
};
